import { __awaiter, __generator } from "tslib";
import { addScriptToPage } from '@office-start/dom-utility';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { DimeState } from './../state';
import { logDimeEvent } from './../telemetry';
import { initializeDime } from './initializeDime';
export var loadDime = function (_a) {
    var dimeJSUrl = _a.dimeJSUrl, puid = _a.puid, upn = _a.upn, pwaEnabled = _a.pwaEnabled, preferredCulture = _a.preferredCulture, sessionId = _a.sessionId;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            if (DimeState.dimeLoadPromise) {
                return [2 /*return*/, DimeState.dimeLoadPromise];
            }
            performance.mark('LoadDimeScript_Started');
            DimeState.dimeLoadPromise = new Promise(function (resolve) {
                addScriptToPage(dimeJSUrl, function () {
                    logDimeEvent({
                        eventName: KnownInstrumentationEvents.DimeLoadScript,
                        dimeExperience: '',
                        result: 'Succeeded',
                    });
                    performance.mark('LoadDimeScript_Completed');
                    initializeDime(puid, upn, pwaEnabled, preferredCulture, sessionId)
                        .then(function () {
                        resolve(1 /* DimeTaskStatus.Completed */);
                    })
                        .catch(function () {
                        resolve(2 /* DimeTaskStatus.Disabled */);
                    });
                }, function () {
                    logDimeEvent({
                        eventName: KnownInstrumentationEvents.DimeLoadScript,
                        dimeExperience: '',
                        result: 'Failed',
                    });
                    resolve(2 /* DimeTaskStatus.Disabled */);
                }, false /* prepend */, 'dimeScriptReact' /* script element id */);
            });
            return [2 /*return*/, DimeState.dimeLoadPromise];
        });
    });
};
//# sourceMappingURL=loadDime.js.map